export default __webpack_public_path__ + "static/media/goods_pettern_right.88047467.jpg";